import { render, staticRenderFns } from "./ContactModel.vue?vue&type=template&id=10aea51d&scoped=true"
import script from "./ContactModel.vue?vue&type=script&lang=js"
export * from "./ContactModel.vue?vue&type=script&lang=js"
import style0 from "./ContactModel.vue?vue&type=style&index=0&id=10aea51d&prod&scoped=true&lang=css"
import style1 from "./ContactModel.vue?vue&type=style&index=1&id=10aea51d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aea51d",
  null
  
)

export default component.exports